var blackwhitetiltednervess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/blackwhitetiltednervess.jpg';
var lgblackwhitewovennercyl = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/lgblackwhitewovennercyl.jpg';
var creamrustcheckedvess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/creamrustcheckedvess.jpg';
var browntoaststripednervess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/browntoaststripednervess.jpg';
var smcheckedblackwhitenercyl = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/smcheckedblackwhitenercyl.jpg';
var creamruststripedvess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/creamruststripedvess.jpg';
var toastbrownspiralnerbowl = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/toastrusttiltednerbowl.jpg';
var toastbrownspiralnerbowlDetail = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/toastbrownspiralnerbowl-detail.jpg';
var lgblackwhitetwistednercyl = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/lgblackwhitetwistednercyl.jpg';
var whitetoasttwistednerovalvess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/whitetoasttwistednerovvess.jpg';
var whitetoasttwistednerovalvessDetail = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/whitetoasttwistednerovvess-detail.jpg';
var lgblackwhitespiralnerbowl = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/lgblackwhitespiralnerbowl.jpg';
var lgblackwhitespiralnerbowlDetail = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/lgblackwhitespiralnerbowl-detail.jpg';
var sepiawovennercyl = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/sepiawovennercyl.jpg';
var bluewhitetwistcyl = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/bluewhitetwistcyl.jpg';
var bluewhitetwistvess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/bluewhitetwistvess.jpg';
var black_white__twist_oblong_nerikomi_vessel2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/black_white__twist_oblong_nerikomi_vessel2.jpg';
var black_white_checked_nerikomi_bottleFront = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/black_white_checked_nerikomi_bottle-front.jpg';
var black_white_checked_nerikomi_bottleBack = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/black_white_checked_nerikomi_bottle-back.jpg';
var black_white_checked_nerikomi_vessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/black_white_checked_nerikomi_vessel.jpg';
var black_white_tall_swirl_nerikomi_bottle = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/black_white_tall_swirl_nerikomi_bottle.jpg';
var black_white_tall_twist_nerikomi_bottle = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/black_white_tall_twist_nerikomi_bottle.jpg';
var black_white_wide_swirl_nerikomi_bottle = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/black_white_wide_swirl_nerikomi_bottle.jpg';
var black_white_wide_twist_nerikomi_bottle_II = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/black_white_wide_twist_nerikomi_bottleII.jpg';
var crisscross3a = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/crisscross3a.jpg';
var crisscross3b = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/crisscross3b.jpg';
var toastcreamstripedgourda = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/toastcreamstripedgourda.jpg';
var toastcreamstripedgourdb = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/toastcreamstripedgourdb.jpg';
var wingsa = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/wingsa.jpg';
var wingsb = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/wingsb.jpg';
var mediumtoastwhitestripedvessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/mediumtoastwhitestripedvessel.jpg';
var crisscross2a = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/crisscross2a.jpg';
var crisscross2b = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/crisscross2b.jpg';
var zigzagnerikomiivessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/zigzagnerikomiivessel.jpg';
var browntannerikomigourda = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/browntannerikomigourda.jpg';
var browntannerikomigourdb = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/browntannerikomigourdb.jpg';
var browntoastnerikomiscoop = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/browntoastnerikomiscoop.jpg';
var largebrowntoaststripednerikomivessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/largebrowntoaststripednerikomivessel.jpg';
var crisscross1a = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/crisscross1a.jpg';
var crisscross1b = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-hb/crisscross1b.jpg';

export const allImagesDesktopOrderClayHB = [
    [/*COLUMN 1*/
        [
            {
                name: crisscross3a,
                artistName: "Lorraine Shemesh",
                title: "Criss-Cross 3",
                year: "2025",
                dimensions: "15 x 13 1/2 x 4 3/8 in., terracotta",
                link: "crisscross3a",
                privateCollection: ""
            },
            {
                name: crisscross3b,
                artistName: "Lorraine Shemesh",
                title: "Criss-Cross 3",
                year: "2025",
                dimensions: "15 x 13 1/2 x 4 3/8 in., terracotta",
                link: "crisscross3b",
                privateCollection: ""
            }
        ],
        [
            {
                name: mediumtoastwhitestripedvessel,
                artistName: "Lorraine Shemesh",
                title: "Medium Toast & White Striped Vessel",
                year: "2025",
                dimensions: "10 x 7 1/2 x 7 in., stoneware & porcelain",
                link: "mediumtoastwhitestripedvessel",
                privateCollection: ""
            }
        ],
        [
            {
                name: browntannerikomigourda,
                artistName: "Lorraine Shemesh",
                title: "Brown & Tan Nerikomi Gourd",
                year: "2025",
                dimensions: "11 x 12 1/2 x 9 1/2 in., stoneware",
                link: "browntannerikomigourda",
                privateCollection: ""
            },            
            {
                name: browntannerikomigourdb,
                artistName: "Lorraine Shemesh",
                title: "Brown & Tan Nerikomi Gourd",
                year: "2025",
                dimensions: "11 x 12 1/2 x 9 1/2 in., stoneware",
                link: "browntannerikomigourdb",
                privateCollection: ""
            }            
        ],
        [
            {
                name: black_white__twist_oblong_nerikomi_vessel2,
                artistName: "Lorraine Shemesh",
                title: "Black & White Twist Oblong Nerikomi Vessel",
                year: "2021",
                dimensions: "12 1/2 x 11 x 11 1/4 in., porcelain",
                link: "clayhb17",
                privateCollection: ""
            }
        ],
        [
            {
                name: black_white_checked_nerikomi_bottleFront,
                artistName: "Lorraine Shemesh",
                title: "Black & White Checked Nerikomi Bottle",
                year: "2021",
                dimensions: "10 3/4 x 7 1/4 x 2 3/4 in., porcelain",
                link: "clayhb18",
                privateCollection: ""
            },
            {
                name: black_white_checked_nerikomi_bottleBack,
                artistName: "Lorraine Shemesh",
                title: "Black & White Checked Nerikomi Bottle - rear view",
                year: "2021",
                dimensions: "10 3/4 x 7 1/4 x 2 3/4 in., porcelain",
                link: "clayhb19",
                privateCollection: ""
            }
        ],
        [
            {
                name: blackwhitetiltednervess,
                artistName: "Lorraine Shemesh",
                title: "Black & White Tilted Nerikomi Vessel",
                year: "2011",
                dimensions: "4 1/2 x 11 x 7 1/2 in., porcelain",
                link: "clayhb1",
                privateCollection: ""
            }
        ],
        [
            {
                name: lgblackwhitewovennercyl,
                artistName: "Lorraine Shemesh",
                title: "Black & White Woven Nerikomi Cylinder",
                year: "2017",
                dimensions: "9 x 9 1/2 x 8 1/2 in., porcelain",
                link: "clayhb2",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: creamrustcheckedvess,
                artistName: "Lorraine Shemesh",
                title: "Cream & Rust Checked Vessel",
                year: "2017",
                dimensions: "7 3/4 x 10 x 10 1/2 in., stoneware",
                link: "clayhb3",
                privateCollection: ""
            }
        ],
        [
            {
                name: bluewhitetwistcyl,
                artistName: "Lorraine Shemesh",
                title: "Blue & White Twist Cylinder",
                year: "2016",
                dimensions: "7 x 7 x 7 in., porcelain",
                link: "clayhb15",
                privateCollection: ""
            }
        ],
        [
            {
                name: browntoaststripednervess,
                artistName: "Lorraine Shemesh",
                title: "Brown & Toast Striped Nerikomi Vessel",
                year: "2016",
                dimensions: "9 1/2 x 10 1/2 x 10 1/2 in., stoneware",
                link: "clayhb4",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: toastcreamstripedgourda,
                artistName: "Lorraine Shemesh",
                title: "Toast & Cream Striped Gourd",
                year: "2025",
                dimensions: "11 x 12 1/4 x  10 1/2 in., stoneware",
                link: "toastcreamstripedgourda",
                privateCollection: ""
            },
            {
                name: toastcreamstripedgourdb,
                artistName: "Lorraine Shemesh",
                title: "Toast & Cream Striped Gourd",
                year: "2025",
                dimensions: "11 x 12 1/4 x  10 1/2 in., stoneware",
                link: "toastcreamstripedgourdb",
                privateCollection: ""
            }
        ],
        [
            {
                name: crisscross2a,
                artistName: "Lorraine Shemesh",
                title: "Criss-Cross 2",
                year: "2025",
                dimensions: "14 1/2 x 14 3/4 x 4 1/8 in., terracotta",
                link: "crisscross2a",
                privateCollection: ""
            },
            {
                name: crisscross2b,
                artistName: "Lorraine Shemesh",
                title: "Criss-Cross 2",
                year: "2025",
                dimensions: "14 1/2 x 14 3/4 x 4 1/8 in., terracotta",
                link: "crisscross2b",
                privateCollection: ""
            }
        ],
        [
            {
                name: browntoastnerikomiscoop,
                artistName: "Lorraine Shemesh",
                title: "Brown & Tan Nerikomi Scoop",
                year: "2025",
                dimensions: "5 1/2 x 17 x 10 1/2 in., stoneware",
                link: "browntoastnerikomiscoop",
                privateCollection: ""
            }
        ],
        [
            {
                name: crisscross1a,
                artistName: "Lorraine Shemesh",
                title: "Criss-Cross 1",
                year: "2025",
                dimensions: "15 x 12 1/2 x 3 1/8 in., terracotta",
                link: "crisscross1a",
                privateCollection: ""
            },
            {
                name: crisscross1b,
                artistName: "Lorraine Shemesh",
                title: "Criss-Cross 1",
                year: "2025",
                dimensions: "15 x 12 1/2 x 3 1/8 in., terracotta",
                link: "crisscross1b",
                privateCollection: ""
            }
        ],
        [
            {
                name: black_white_wide_swirl_nerikomi_bottle,
                artistName: "Lorraine Shemesh",
                title: "Black & White Wide Swirl Nerikomi Bottle",
                year: "2021",
                dimensions: "8 1/2 x 10 1/2 x  3 1/4 in., porcelain",
                link: "clayhb23",
                privateCollection: ""
            }
        ],
        [
            {
                name: black_white_wide_twist_nerikomi_bottle_II,
                artistName: "Lorraine Shemesh",
                title: "Black & White Wide Twist Nerikomi Bottle II",
                year: "2021",
                dimensions: "8 1/2 x 10 1/4 x 3 1/4 in., porcelain",
                link: "clayhb24",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: black_white_tall_twist_nerikomi_bottle,
                artistName: "Lorraine Shemesh",
                title: "Black & White Tall Twist Nerikomi Bottle",
                year: "2021",
                dimensions: "11 x 8 x 2 3/4 in., porcelain",
                link: "clayhb22",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: smcheckedblackwhitenercyl,
                artistName: "Lorraine Shemesh",
                title: "Small Checked Black & White Nerikomi Cylinder",
                year: "2015",
                dimensions: "5 1/8 x 5 x 5 in., porcelain",
                link: "clayhb5",
                privateCollection: ""
            }
        ],
        [
            {
                name: creamruststripedvess,
                artistName: "Lorraine Shemesh",
                title: "Cream & Rust Striped Vessel",
                year: "2016",
                dimensions: "9 1/2 x 10 1/2 x 10 1/2 in., stoneware",
                link: "clayhb6",
                privateCollection: ""
            }
        ],
        [
            {
                name: lgblackwhitetwistednercyl,
                artistName: "Lorraine Shemesh",
                title: "Large Black & White Twisted Nerikomi Cylinder",
                year: "2011",
                dimensions: "9 1/4 x 9 3/4 x 9 1/2 in., porcelain",
                link: "clayhb9",
                privateCollection: ""
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: wingsa,
                artistName: "Lorraine Shemesh",
                title: "Wings",
                year: "2025",
                dimensions: "14 x 14 1/4 x 5 7/8 in., stoneware",
                link: "wingsa",
                privateCollection: ""
            },
            {
                name: wingsb,
                artistName: "Lorraine Shemesh",
                title: "Wings",
                year: "2025",
                dimensions: "14 x 14 1/4 x 5 7/8 in., stoneware",
                link: "wingsb",
                privateCollection: ""
            }
        ],
        [
            {
                name: zigzagnerikomiivessel,
                artistName: "Lorraine Shemesh",
                title: "Zig-Zag Nerikomi Vessel",
                year: "2025",
                dimensions: "14 1/4 x 10 1/2 x 10 1/2 in., stoneware",
                link: "zigzagnerikomiivessel",
                privateCollection: ""
            }            
        ],
        [
            {
                name: largebrowntoaststripednerikomivessel,
                artistName: "Lorraine Shemesh",
                title: "Large Brown & Toast Striped Nerikomi Vessel",
                year: "2025",
                dimensions: "15 7/8 x 9 x 9 in., stoneware",
                link: "largebrowntoaststripednerikomivessel",
                privateCollection: ""
            }            
        ],
        [
            {
                name: black_white_checked_nerikomi_vessel,
                artistName: "Lorraine Shemesh",
                title: "Black & White Checked Nerikomi Vessel",
                year: "2021",
                dimensions: "10 3/4 x 9 5/8 x 9 in., porcelain",
                link: "clayhb20",
                privateCollection: ""
            }
        ],
        [
            {
                name: black_white_tall_swirl_nerikomi_bottle,
                artistName: "Lorraine Shemesh",
                title: "Black & White Tall Swirl Nerikomi Bottle",
                year: "2021",
                dimensions: "10 5/8  x 7 5/8 x 2 3/4 in., porcelain",
                link: "clayhb21",
                privateCollection: ""
            }
        ],
        [
            {    
                name: whitetoasttwistednerovalvess,
                artistName: "Lorraine Shemesh",
                title: "White & Toast Twisted Vessel",
                year: "2011",
                dimensions: "8 x 10 x 8 3/4 in., porcelain & stoneware",
                link: "clayhb10",
                privateCollection: ""
            },
            {
                name: whitetoasttwistednerovalvessDetail,
                artistName: "Lorraine Shemesh",
                title: "White & Toast Twisted Vessel - detail",
                year: "2011",
                dimensions: "8 x 10 x 8 3/4 in., porcelain & stoneware",
                link: "clayhb11",
                privateCollection: ""
            }
        ],
        [
            {
                name: lgblackwhitespiralnerbowl,
                artistName: "Lorraine Shemesh",
                title: "Large Black & White Spiral Nerikomi Bowl",
                year: "2000",
                dimensions: "5 x 20 x 20 in., porcelain",
                link: "clayhb12",
                privateCollection: ""
            },
            {
                name: lgblackwhitespiralnerbowlDetail,
                artistName: "Lorraine Shemesh",
                title: "Large Black & White Spiral Nerikomi Bowl - detail",
                year: "2000",
                dimensions: "5 x 20 x 20 in., porcelain",
                link: "clayhb13",
                privateCollection: ""
            }
        ],
        [
            {
                name: sepiawovennercyl,
                artistName: "Lorraine Shemesh",
                title: "Sepia Woven Nerikomi Cylinder",
                year: "1998",
                dimensions: "11 x 10 x 10 in., stoneware",
                link: "clayhb14",
                privateCollection: ""
            }
        ],
        [
            {
                name: bluewhitetwistvess,
                artistName: "Lorraine Shemesh",
                title: "Blue & White Twist Vessel",
                year: "2015",
                dimensions: "7 1/2 x 8 x 8 in., porcelain",
                link: "clayhb16",
                privateCollection: ""
            }
        ],
        [
            {
                name: toastbrownspiralnerbowl,
                artistName: "Lorraine Shemesh",
                title: "Toast & Brown Spiral Nerikomi Bowl",
                year: "2011",
                dimensions: "7 3/4 x 14 1/2 x 13 3/4 in., stoneware",
                link: "clayhb7",
                privateCollection: ""
            },
            {
                name: toastbrownspiralnerbowlDetail,
                artistName: "Lorraine Shemesh",
                title: "Toast & Brown Spiral Nerikomi Bowl - detail",
                year: "2011",
                dimensions: "7 3/4 x 14 1/2 x 13 3/4 in., stoneware",
                link: "clayhb8",
                privateCollection: ""
            }
        ]
    ]          
]

export const allImagesMobileOrderClayHB = [
    [{
        name: crisscross3b,
        artistName: "Lorraine Shemesh",
        title: "Criss-Cross 3",
        year: "2025",
        dimensions: "15 x 13 1/2 x 4 3/8 in., terracotta",
        link: "crisscross3b",
        privateCollection: ""
    },
    {
        name: toastcreamstripedgourda,
        artistName: "Lorraine Shemesh",
        title: "Toast & Cream Striped Gourd",
        year: "2025",
        dimensions: "11 x 12 1/4 x  10 1/2 in., stoneware",
        link: "toastcreamstripedgourda",
        privateCollection: ""
    },
    {
        name: wingsa,
        artistName: "Lorraine Shemesh",
        title: "Wings",
        year: "2025",
        dimensions: "14 x 14 1/4 x 5 7/8 in., stoneware",
        link: "wingsa",
        privateCollection: ""
    },
    {
        name: mediumtoastwhitestripedvessel,
        artistName: "Lorraine Shemesh",
        title: "Medium Toast & White Striped Vessel",
        year: "2025",
        dimensions: "10 x 7 1/2 x 7 in., stoneware & porcelain",
        link: "mediumtoastwhitestripedvessel",
        privateCollection: ""
    },
    {
        name: crisscross2a,
        artistName: "Lorraine Shemesh",
        title: "Criss-Cross 2",
        year: "2025",
        dimensions: "14 1/2 x 14 3/4 x 4 1/8 in., terracotta",
        link: "crisscross2a",
        privateCollection: ""
    },
    {
        name: zigzagnerikomiivessel,
        artistName: "Lorraine Shemesh",
        title: "Zig-Zag Nerikomi Vessel",
        year: "2025",
        dimensions: "14 1/4 x 10 1/2 x 10 1/2 in., stoneware",
        link: "zigzagnerikomiivessel",
        privateCollection: ""
    },       
    {
        name: browntannerikomigourda,
        artistName: "Lorraine Shemesh",
        title: "Brown & Tan Nerikomi Gourd",
        year: "2025",
        dimensions: "11 x 12 1/2 x 9 1/2 in., stoneware",
        link: "browntannerikomigourda",
        privateCollection: ""
    },            
    {
        name: browntoastnerikomiscoop,
        artistName: "Lorraine Shemesh",
        title: "Brown & Tan Nerikomi Scoop",
        year: "2025",
        dimensions: "5 1/2 x 17 x 10 1/2 in., stoneware",
        link: "browntoastnerikomiscoop",
        privateCollection: ""
    },
    {
        name: largebrowntoaststripednerikomivessel,
        artistName: "Lorraine Shemesh",
        title: "Large Brown & Toast Striped Nerikomi Vessel",
        year: "2025",
        dimensions: "15 7/8 x 9 x 9 in., stoneware",
        link: "largebrowntoaststripednerikomivessel",
        privateCollection: ""
    },
    {
        name: crisscross1a,
        artistName: "Lorraine Shemesh",
        title: "Criss-Cross 1",
        year: "2025",
        dimensions: "15 x 12 1/2 x 3 1/8 in., terracotta",
        link: "crisscross1a",
        privateCollection: ""
    },
    {
        name: black_white__twist_oblong_nerikomi_vessel2,
        artistName: "Lorraine Shemesh",
        title: "Black & White Twist Oblong Nerikomi Vessel",
        year: "2021",
        dimensions: "12 1/2 x 11 x 11 1/4 in., porcelain",
        link: "clayhb17",
        privateCollection: ""
    },
    {
        name: black_white_checked_nerikomi_bottleFront,
        artistName: "Lorraine Shemesh",
        title: "Black & White Checked Nerikomi Bottle",
        year: "2021",
        dimensions: "10 3/4 x 7 1/4 x 2 3/4 in., porcelain",
        link: "clayhb18",
        privateCollection: ""
    },
    {
        name: black_white_wide_swirl_nerikomi_bottle,
        artistName: "Lorraine Shemesh",
        title: "Black & White Wide Swirl Nerikomi Bottle",
        year: "2021",
        dimensions: "8 1/2 x 10 1/2 x  3 1/4 in., porcelain",
        link: "clayhb23",
        privateCollection: ""
    },
    {
        name: black_white_wide_twist_nerikomi_bottle_II,
        artistName: "Lorraine Shemesh",
        title: "Black & White Wide Twist Nerikomi Bottle II",
        year: "2021",
        dimensions: "8 1/2 x 10 1/4 x 3 1/4 in., porcelain",
        link: "clayhb24",
        privateCollection: "Private Collection"
    },
    {
        name: black_white_tall_twist_nerikomi_bottle,
        artistName: "Lorraine Shemesh",
        title: "Black & White Tall Twist Nerikomi Bottle",
        year: "2021",
        dimensions: "11 x 8 x 2 3/4 in., porcelain",
        link: "clayhb22",
        privateCollection: "Private Collection"
    },
    {
        name: black_white_checked_nerikomi_vessel,
        artistName: "Lorraine Shemesh",
        title: "Black & White Checked Nerikomi Vessel",
        year: "2021",
        dimensions: "10 3/4 x 9 5/8 x 9 in., porcelain",
        link: "clayhb20",
        privateCollection: ""
    },
    {
        name: black_white_tall_swirl_nerikomi_bottle,
        artistName: "Lorraine Shemesh",
        title: "Black & White Tall Swirl Nerikomi Bottle",
        year: "2021",
        dimensions: "10 5/8  x 7 5/8 x 2 3/4 in., porcelain",
        link: "clayhb21",
        privateCollection: ""
    },
    {
        name: blackwhitetiltednervess,
        artistName: "Lorraine Shemesh",
        title: "Black & White Tilted Nerikomi Vessel",
        year: "2011",
        dimensions: "4 1/2 x 11 x 7 1/2 in., porcelain",
        link: "clayhb1",
        privateCollection: ""
    },
    {
        name: lgblackwhitewovennercyl,
        artistName: "Lorraine Shemesh",
        title: "Black & White Woven Nerikomi Cylinder",
        year: "2017",
        dimensions: "9 x 9 1/2 x 8 1/2 in., porcelain",
        link: "clayhb2",
        privateCollection: "Private Collection"
    },
    {
        name: creamrustcheckedvess,
        artistName: "Lorraine Shemesh",
        title: "Cream & Rust Checked Vessel",
        year: "2017",
        dimensions: "7 3/4 x 10 x 10 1/2 in., stoneware",
        link: "clayhb3",
        privateCollection: ""
    },
    {
        name: bluewhitetwistcyl,
        artistName: "Lorraine Shemesh",
        title: "Blue & White Twist Cylinder",
        year: "2016",
        dimensions: "7 x 7 x 7 in., porcelain",
        link: "clayhb15",
        privateCollection: ""
    },
    {
        name: browntoaststripednervess,
        artistName: "Lorraine Shemesh",
        title: "Brown & Toast Striped Nerikomi Vessel",
        year: "2016",
        dimensions: "9 1/2 x 10 1/2 x 10 1/2 in., stoneware",
        link: "clayhb4",
        privateCollection: "Private Collection"
    },
    {
        name: smcheckedblackwhitenercyl,
        artistName: "Lorraine Shemesh",
        title: "Small Checked Black & White Nerikomi Cylinder",
        year: "2015",
        dimensions: "5 1/8 x 5 x 5 in., porcelain",
        link: "clayhb5",
        privateCollection: ""
    },
    {
        name: creamruststripedvess,
        artistName: "Lorraine Shemesh",
        title: "Cream & Rust Striped Vessel",
        year: "2016",
        dimensions: "9 1/2 x 10 1/2 x 10 1/2 in., stoneware",
        link: "clayhb6",
        privateCollection: ""
    },
    {
        name: toastbrownspiralnerbowl,
        artistName: "Lorraine Shemesh",
        title: "Toast & Brown Spiral Nerikomi Bowl",
        year: "2011",
        dimensions: "7 3/4 x 14 1/2 x 13 3/4 in., stoneware",
        link: "clayhb7",
        privateCollection: ""
    },
    {
        name: toastbrownspiralnerbowlDetail,
        artistName: "Lorraine Shemesh",
        title: "Toast & Brown Spiral Nerikomi Bowl - detail",
        year: "2011",
        dimensions: "7 3/4 x 14 1/2 x 13 3/4 in., stoneware",
        link: "clayhb8",
        privateCollection: ""
    },
    {
        name: lgblackwhitetwistednercyl,
        artistName: "Lorraine Shemesh",
        title: "Large Black & White Twisted Nerikomi Cylinder",
        year: "2011",
        dimensions: "9 1/4 x 9 3/4 x 9 1/2 in., porcelain",
        link: "clayhb9",
        privateCollection: ""
    },
    {    
        name: whitetoasttwistednerovalvess,
        artistName: "Lorraine Shemesh",
        title: "White & Toast Twisted Vessel",
        year: "2011",
        dimensions: "8 x 10 x 8 3/4 in., porcelain & stoneware",
        link: "clayhb10",
        privateCollection: ""
    },
    {
        name: whitetoasttwistednerovalvessDetail,
        artistName: "Lorraine Shemesh",
        title: "White & Toast Twisted Vessel - detail",
        year: "2011",
        dimensions: "8 x 10 x 8 3/4 in., porcelain & stoneware",
        link: "clayhb11",
        privateCollection: ""
    },
    {
        name: lgblackwhitespiralnerbowl,
        artistName: "Lorraine Shemesh",
        title: "Large Black & White Spiral Nerikomi Bowl",
        year: "2000",
        dimensions: "5 x 20 x 20 in., porcelain",
        link: "clayhb12",
        privateCollection: ""
    },
    {
        name: lgblackwhitespiralnerbowlDetail,
        artistName: "Lorraine Shemesh",
        title: "Large Black & White Spiral Nerikomi Bowl - detail",
        year: "2000",
        dimensions: "5 x 20 x 20 in., porcelain",
        link: "clayhb13",
        privateCollection: ""
    },
    {
        name: sepiawovennercyl,
        artistName: "Lorraine Shemesh",
        title: "Sepia Woven Nerikomi Cylinder",
        year: "1998",
        dimensions: "11 x 10 x 10 in., stoneware",
        link: "clayhb14",
        privateCollection: ""
    },
    {
        name: bluewhitetwistvess,
        artistName: "Lorraine Shemesh",
        title: "Blue & White Twist Vessel",
        year: "2015",
        dimensions: "7 1/2 x 8 x 8 in., porcelain",
        link: "clayhb16",
        privateCollection: ""
    }]      
]
